{
  "longPressMessage": "Premere a lungo o premere Alt + Freccia giù per aprire il menu"
}
